
export default function Logo() {
    return (


        <svg width="170" height="30" viewBox="0 0 170 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.0366 6.3623H7.15657V11.7977H16.4505V17.8231H7.15657V23.6377H22.9942V30H0V0H23.0366V6.3623Z" fill="var(--global-background)" />
            <path d="M35.9188 4.33984L40.2311 11.7977C41.9222 8.67972 43.3174 6.17971 44.4167 4.29769L46.9534 0H54.817L43.6557 18.3286V30H36.5108V18.3286L25.2226 0H33.2975L35.9188 4.33984Z" fill="var(--global-background)" />
            <path d="M56.8348 23.6667H73.6499V30H50.9496V17.8333H56.8348V23.6667Z" fill="var(--global-background)" />
            <path d="M85.813 23.6377H99.545V30H78.6944V0H85.813V23.6377Z" fill="var(--global-background)" />
            <path d="M109.97 30H102.908V0H109.97V30Z" fill="var(--global-background)" />
            <path d="M135.184 19.4827V0H141.751V30H135.141L121.75 10.5173V30H115.183V0H121.75L135.184 19.4827Z" fill="var(--global-background)" />
            <path d="M170 6.3623H154.12V11.7977H163.414V17.8231H154.12V23.6377H169.958V30H146.963V0H170V6.3623Z" fill="var(--global-background)" />
            <path d="M65.5786 17.8333H56.8348V11.8333H65.5786V17.8333Z" fill="var(--global-background)" />
            <path d="M73.6499 0V6.33333H63.729V0H73.6499Z" fill="var(--global-background)" />
        </svg>

    );
}